import moment from 'moment'
import Icons from 'assets/icons'
import { currencyTypes, getAlertClass, isAdmin, isAM, isPM } from 'utils/Constants'
import { Dropdown } from 'primereact/dropdown'
import { Calendar } from 'primereact/calendar'
import { InputNumber } from 'primereact/inputnumber'
import {useDispatch, useSelector} from 'react-redux'
import {setEdittedRow, updateEdittedRow} from 'redux/features/projectDetail/projectDetailSlice'
import {openInlineApprovalModal} from 'redux/features/general/generalSlice'
import DefaultSelect from 'components/formElements/DefaultSelect'
import useToast from './useToast'
const useEditor = () => {
	const { edittedRow } = useSelector((state) => state.projectDetail)
	const {showToast} = useToast()
	const dispatch = useDispatch()
	const textAreaEditor = (options) => {
		return (
			<textarea className='default-textarea' type='text' rows={4} value={edittedRow[options.field]} onChange={(e) => dispatch(updateEdittedRow({key:options.field,value:e.target.value ? e.target.value : ''}))} />
		)
	}
	const textEditor = (options) => {
		return <input type='text' className='default-input small-input' value={edittedRow[options.field]} onChange={(e) => dispatch(updateEdittedRow({key:options.field,value:e.target.value ? e.target.value : null}))} />
	}
	const numberEditor = (options, budget) => {
		const {rowData} = options
		return <input type='text' className='default-input small-input' value={edittedRow[options.field]} onChange={(e) => {
			e.target.value = e.target.value.replace(/[^0-9.-]/g, '').replace(/(\..*)\./g, '$1')
			budget 
			? dispatch(setEdittedRow({...rowData, budget:e.target.value * budget,[options.field]:e.target.value }))
			: dispatch(updateEdittedRow({ key:options.field,value:e.target.value ? e.target.value.replace(/[^0-9.-]/g, '').replace(/(\..*)\./g, '$1') : null}))
			
		}} />
	}
	const percentEditor = (options,budget) => {
		const {rowData} = options
		return <InputNumber mode="decimal" className='small-input' max={100} onBlur={e => {
			if(e.target.value && budget) {
				dispatch(setEdittedRow({...rowData,amount:e.target.value * budget / 100,[options.field]:e.target.value}))
			}
			dispatch(updateEdittedRow({key:options.field,value:e.target.value}))
		}} value={edittedRow[options.field]} onChange={(e) => {
			if(e.value && budget) {
				dispatch(setEdittedRow({...rowData,amount:e.value * budget / 100,[options.field]:e.value}))
			}
			dispatch(updateEdittedRow({key:options.field,value:e.value}))
		}} />
	}
	const currencyEditor = (options) => {
		return <div className='p-inputgroup'>
			<InputNumber mode="decimal" className='small-input' maxFractionDigits={2} minFractionDigits={2} placeholder='Tutar' style={{ width: '60%' }} name='amount' value={edittedRow[options.field]} onChange={(e) => dispatch(updateEdittedRow({key:options.field,value:e.value ? e.value : null}))} />
			<Dropdown placeholder="Para Birimi" className='small-input' style={{ width: '40%' }} value={edittedRow.currency} onChange={(e) => dispatch(updateEdittedRow({key:'currency',value:e.value ? e.value : null}))} options={currencyTypes} optionLabel='label' optionValue='value' />
		</div>
	}
	const currencyEditorWithoutDigit = (options) => {
		return <div className='p-inputgroup'>
			<InputNumber mode="decimal" className='small-input' maxFractionDigits={0} minFractionDigits={0} placeholder='Tutar' style={{ width: '60%' }} name='amount' value={edittedRow[options.field]} onChange={(e) => dispatch(updateEdittedRow({key:options.field,value:e.value ? e.value : null}))} />
			<Dropdown placeholder="Para Birimi" className='small-input' style={{ width: '40%' }} value={edittedRow.currency} onChange={(e) => dispatch(updateEdittedRow({key:'currency',value:e.value ? e.value : null}))} options={currencyTypes} optionLabel='label' optionValue='value' />
		</div>
	}
	const calendarEditor = (options) => {
		return <Calendar
			dateFormat='dd/mm/yy'
			className='small-input'
			placeholder='Tarih Seçiniz'
			value={edittedRow[options.field] && new Date(edittedRow[options.field])}
			onChange={(e) => {
				dispatch(updateEdittedRow({key:options.field,value:moment(e.target.value).add(3, 'hours').toISOString()}))
			}}
		/>
	}
	const calendarStartEndEditor = (options, startField, endField) => {
		return <div className='d-flex gap-2'>
			<Calendar
				dateFormat='dd/mm/yy'
				className='small-input'
				placeholder='Tarih Seçiniz'
				value={edittedRow[startField] && new Date(edittedRow[startField])}
				onChange={(e) => {
					dispatch(updateEdittedRow({key:startField,value:moment(e.target.value).add(3, 'hours').toISOString()}))
				}}
			/>
			<Calendar
				dateFormat='dd/mm/yy'
				className='small-input'
				placeholder='Tarih Seçiniz'
				value={edittedRow[endField] && new Date(edittedRow[endField])}
				onChange={(e) => {
					dispatch(updateEdittedRow({key:endField,value:moment(e.target.value).add(3, 'hours').toISOString()}))
				}}
			/>
		</div>
	}
	const calendarShortDateEditor = (options) => {
		return <Calendar
			className='small-input'
			placeholder='Tarih Seçiniz'
			value={edittedRow[options.field] && moment(edittedRow[options.field]).locale('en')._d}
			view="month" 
			dateFormat="mm/yy"
			onChange={(e) => {
				dispatch(updateEdittedRow({key:options.field,value:moment(e.target.value).add(3, 'hours').toISOString()}))
			}}
		/>
	}
	const InvoiceSelectEditorForReports = (options, selectOptions, withoutColors) => {
		return (
			<Dropdown
				optionLabel='label'
				optionValue='value'
				className='small-input'
				options={isAdmin ? selectOptions : [{label:'Kesilebilir',value:2},{label:'Bekliyor',value:3},{label:'Müşteri Onayı Bekliyor',value:5}]}
				value={edittedRow[options.field]}
				onChange={(e) => {
					dispatch(updateEdittedRow({key:options.field,value:e.value ? e.value : null}))
					if (e.value == 1) {
						dispatch(openInlineApprovalModal({ open: true, invoiceStatusId: e.value, text: 'Ödeme tarihini bugün olarak güncellemek ister misiniz?' }))
					} else if (e.value == 2) {
						dispatch(openInlineApprovalModal({ open: true, invoiceStatusId: e.value, text: 'Ödeme Onayı Belgesi' }))
					}else if (e.value == 7) {
						dispatch(openInlineApprovalModal({ open: true, invoiceStatusId: e.value, text: 'Fatura No ve Ödeme Onayı Belgesi'  }))
					}
				}}
				itemTemplate={(option) => {
					return <span className={!withoutColors && getAlertClass(option?.value)}>{option.label}</span>
				}}
			/>
		)
	}
	const InvoiceSelectEditor = (options, selectOptions, withoutColors) => {
		return (
			<Dropdown
				optionLabel='label'
				optionValue='value'
				className='small-input'
				options={edittedRow[options.field] == 1 ? [...selectOptions,{label:'Ödendi',value:1}] : edittedRow[options.field] == 7 ?[...selectOptions,{label:'Fatura Kesildi',value:7}]:  selectOptions}
				disabled={edittedRow[options.field] == 1 || edittedRow[options.field] == 7}
				value={edittedRow[options.field]}
				onChange={(e) => {
					let oldStatus = edittedRow[options.field]

					if (isAM && oldStatus == 3) {
						showToast('Account Manager olarak mevcut fatura durumunu değiştiremezsiniz','error')
						return
					}

					if (oldStatus == 3 && e.value == 5) {
						dispatch(openInlineApprovalModal({ open: true, invoiceStatusId: e.value, text: 'İlgili faturanın sorumlusu Account Manager olarak atanacak ve mail ile bilgilendirme yapılacaktır. Değişikliği yapmak istiyor musunuz?' }))
						return
					} else if (isPM) {
						showToast('Proje yöneticisi olarak mevcut fatura durumunu değiştiremezsiniz','error')
						return
					}

					dispatch(updateEdittedRow({key:options.field,value:e.value ? e.value : null}))
					if (e.value == 1) {
						dispatch(openInlineApprovalModal({ open: true, invoiceStatusId: e.value, text: 'Ödeme tarihini bugün olarak güncellemek ister misiniz?' }))
					} else if (e.value == 2) {
						dispatch(openInlineApprovalModal({ open: true, invoiceStatusId: e.value, text: 'Ödeme Onayı Belgesi' }))
					}else if (e.value == 7) {
						dispatch(openInlineApprovalModal({ open: true, invoiceStatusId: e.value, text: 'Fatura No ve Ödeme Onayı Belgesi'  }))
					}
				}}
				itemTemplate={(option) => {
					return <span className={!withoutColors && (option.value == 1 ? 'alert-success' : (option.value == 3 || option.value == 5) ? 'alert-warning' : 'alert-info')}>{option.label}</span>
				}}
			/>
		)
	}
	const selectEditor = (options, selectOptions, withoutColors) => {
		return (
			<Dropdown
				optionLabel='label'
				optionValue='value'
				className='small-input'
				options={selectOptions}
				value={edittedRow[options.field]}
				disabled={options.disabled || false}
				onChange={(e) => dispatch(updateEdittedRow({key:options.field,value:e.value ? e.value : null}))}
				itemTemplate={(option) => {
					return <span className={!withoutColors && (option.value == 1 ? 'alert-success' : (option.value == 3 || option.value == 5) ? 'alert-warning' : 'alert-info')}>{option.label}</span>
				}}
			/>
		)
	}
	const multiSelectEditor = (options, selectOptions) => {
		return (
			<DefaultSelect
				isMulti
				className='small-input'
				value={edittedRow[options.field] && edittedRow[options.field]?.split('+').map(f => ({label:f,value:f}))}
				selectOptions={selectOptions}
				handleChange={e => dispatch(updateEdittedRow({key:options.field,value:e ? e?.map(t => t.value)?.join('+') : null}))}
			/>
		)
	}
	const rowEditorBody = (d) => (
		d.rowEditor.editing ? <span className='d-flex flex-column align-items-end'>
			<Icons.check
				size={16}
				className='text-success cursor-pointer mr-1'
				onClick={(e) => {
					d.rowEditor.onSaveClick(e)
				}}
			/>
			<Icons.close
				size={26}
				className='text-default cursor-pointer'
				onClick={(e) => {
					dispatch(setEdittedRow({}))
					d.rowEditor.onCancelClick(e)
				}}
			/>
		</span>
			: <span className='d-flex justify-content-end'>
				<Icons.edit
					size={20}
					className='text-primary cursor-pointer'
					onClick={(e) => {
						if (Object.keys(edittedRow)?.length > 0) {
							showToast('Önce açık bırakılan düzenleme işlemini tamamlayınız','error')
						}else {
							d.rowEditor.onInitClick(e)
						}
					}} />
			</span>
	)


	return { textAreaEditor, textEditor, calendarEditor, selectEditor, rowEditorBody, currencyEditor,percentEditor,InvoiceSelectEditor, calendarShortDateEditor, InvoiceSelectEditorForReports, numberEditor, currencyEditorWithoutDigit, multiSelectEditor, calendarStartEndEditor }
}

export default useEditor
